import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import Aos from "aos";
import { getWebsitePolicy } from "../Common/apis";
import Loader from '../Loader/Loader'

function Privacy() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  console.log(data);

  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);

  useEffect(() => {
    getWebsitePolicy()
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      }).finally(() => setLoading(false));
  }, []);
  return (
    <>
      <div className="main-div2">
        <Navbar />
        {loading && <Loader />}
        <h6 className="font-[500] text-center pt-[130px] pb-[56px] md:text-[110px] text-[60px] md:leading-[119px] leading-[70px] text-[#000000]">
          Privacy{" "}
          <span className="italic text-[#6953A3] font-dmserif">Policy</span>
        </h6>
        <div
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)"
          }}
          className="rounded-[19px] border-[1px] border-[#B99FFF] max-w-[1234px] w-full mx-auto py-[55px] px-[36px]"
        >
          <div dangerouslySetInnerHTML={{ __html: data?.privacyPolicy }} />
          {/* <h2 className="font-[400] font-sans text-[20px] leading-[26px] text-[#000000] pb-[30px]">
            At GISUL, we are committed to protecting your privacy and ensuring
            the security of your personal information. This Privacy Policy
            outlines how we collect, use, and safeguard your data when you
            interact with our services.
          </h2>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] pb-[30px]">
            1. Information We Collect
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            We may collect the following types of information:
            <ul className="list-disc pl-[20px]">
              <li>
                <span className="font-[500]">Personal Information:</span> Name,
                email address, phone number, and billing information provided
                during course registration.
              </li>
              <li>
                <span className="font-[500]">Account Information:</span> Login
                credentials and preferences associated with your GISUL account.
              </li>
              <li>
                <span className="font-[500]">Usage Data: </span> Information
                about your interactions with our website, including pages
                visited, time spent, and device information.
              </li>
              <li>
                <span className="font-[500]">Payment Information: </span> Name,
                email address, phone number, and billing information provided
                during course registration.
              </li>
              <li>
                <span className="font-[500]">Communication Data: </span>Records
                of correspondence, including emails and inquiries.
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            2. How We Use Your Information
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            We use your data for the following purposes:
            <ul className="list-disc pl-[20px]">
              <li>
                <span className="font-[500]">Service Delivery: </span> To
                process your registration, deliver courses, and provide learning
                resources.
              </li>
              <li>
                <span className="font-[500]">Account Management:</span> To
                create and manage user accounts and preferences.
              </li>
              <li>
                <span className="font-[500]">Payment Processing: </span> To
                handle transactions securely through trusted third-party payment
                processors.
              </li>
              <li>
                <span className="font-[500]">Support Services: </span>To address
                inquiries, provide assistance, and resolve technical issues.
              </li>
              <li>
                <span className="font-[500]">Course Improvement: </span>To
                enhance course content, learning experiences, and platform
                functionality.
              </li>
              <li>
                <span className="font-[500]">
                  Marketing and Communication:{" "}
                </span>
                To send updates, promotions, and newsletters (only if you
                opt-in).
              </li>
              <li>
                <span className="font-[500]">Legal Compliance: </span>To comply
                with applicable laws, regulations, and legal processes.
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            3. Data Sharing and Third Parties
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            We do not sell your personal information. However, we may share your
            data with trusted third parties under the following conditions:
            <ul className="list-disc pl-[20px]">
              <li>
                <span className="font-[500]">Service Providers:</span> For
                payment processing, email communication, and technical support.
              </li>
              <li>
                <span className="font-[500]">Legal Requirements:</span> When
                required by law or to protect the rights, property, or safety of
                GISUL and its users.
              </li>
              <li>
                <span className="font-[500]">Business Transfers: </span> In the
                event of a merger, acquisition, or transfer of assets.
              </li>
              <li>
                All third parties are contractually obligated to protect your
                data and comply with privacy regulations.
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            4. Data Security
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            We implement industry-standard security measures, including:
            <ul className="list-disc pl-[20px]">
              <li>
                <span className="font-[500]">Encryption: </span> Secure data
                transmission through SSL (Secure Socket Layer).
              </li>
              <li>
                <span className="font-[500]">Access Controls:</span> Restricted
                access to personal information.
              </li>
              <li>
                <span className="font-[500]">Data Storage Protections: </span>{" "}
                Secure servers and backups to prevent unauthorized access.
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            5. Data Retention
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            We retain your information only as long as necessary to fulfill the
            purposes outlined in this policy or as required by law. After that,
            we securely delete or anonymize your data.
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            6. Your Privacy Rights
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            You have the right to:
            <ul className="list-disc pl-[20px]">
              <li>
                <span className="font-[500]">Access and Update: </span> Review
                and update your personal information.
              </li>
              <li>
                <span className="font-[500]">Delete Data: </span> Request the
                deletion of your data, subject to legal and operational
                requirements.
              </li>
              <li>
                <span className="font-[500]">Opt-Out of Marketing: </span>{" "}
                Unsubscribe from promotional emails at any time.
              </li>
              <li>
                <span className="font-[500]">Data Portability: </span> Request a
                copy of your data in a commonly used format.
              </li>
              <li>
                To exercise these rights, contact us at [Insert Contact Email].
              </li>
            </ul>
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            7. Cookies and Tracking Technologies
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            We use cookies and similar technologies to:
            <ul className="list-disc pl-[20px]">
              <li>Enhance user experience.</li>
              <li>Analyze website traffic and usage.</li>
              <li>Provide personalized recommendations and ads.</li>
            </ul>
            You can manage cookie preferences through your browser settings.
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            8. Children’s Privacy
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            GISUL services are not directed toward children under 13. We do not
            knowingly collect personal information from children without
            parental consent.
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            9. Changes to This Policy
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            We may update this Privacy Policy periodically. Any changes will be
            posted on this page with the Effective Date updated. We encourage
            you to review it regularly.
          </p>
          <h6 className="font-[400] font-sans text-[32px] leading-[34px] text-[#000000] py-[30px]">
            10. Contact Us
          </h6>
          <p className="font-[400] font-sans text-[16px] leading-[28.8px] text-[#000000]">
            If you have any questions or concerns about this Privacy Policy,
            please contact us at:
            <ul className="">
              <li>
                <span className="font-[500]">Email: </span>
              </li>
              <li>
                <span className="font-[500]">Phone: </span>
              </li>
              <li>
                <span className="font-[500]">Address: </span>
              </li>
            </ul>
            GISUL values your trust and is committed to protecting your privacy
            at every step.
          </p> */}
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Privacy;
